<ng-template #addHighlightModal let-modal>
  <div class="drop-head">
    <h4 class="drop-title">Add Highlight</h4>
    <button class="btn btn-close" (click)="modal.close('Close click')"></button>
  </div>
  <div class="drop-body">
    <div class="text-view-block">
      <span title="{{title}}">
        {{title?.length>100? title?.slice(0,100)+"...":title}}
      </span>
    </div>
    <div class="NgxEditor__Wrapper">
      <ngx-editor [editor]="editor" [outputFormat]="'html'" [(ngModel)]="titleValue" [disabled]="false"
        [placeholder]="'Type here...'"></ngx-editor>
    </div>
  </div>
  <div class="drop-footer">
    <div>
      <div>
        <ngx-editor-menu [editor]="editor" [toolbar]="toolbar" [dropdownPlacement]="'bottom'">
        </ngx-editor-menu>
      </div>

    </div>
    <div>
      <button class="btn btn-text" title="Cancel" ngbAutofocus (click)="modal.close('Close click')">Cancel</button>
      <button class="btn btn-outline-secondary" title="Add" (click)="addTitleToHightLightText($event)">Add</button>
    </div>
  </div>
</ng-template>